<div class="wishlist-hotel-popup">
    <div class="wishlist-hotel-popup-content">
        <img
                [src]="isAdded ? '/x-assets/img/emoji/white-heart-in-red-square.svg' : '/x-assets/img/emoji/emoji-ok.png'"
                class="emoji"
                [alt]="isAdded ? 'success' : 'ok'"
        >
        <div>
            <span class="wishlist-hotel-popup__title">{{ isAdded ? messages.successLabel : messages.doneLabel }}</span>
            <span class="wishlist-hotel-popup__hint">
                {{ isAdded ? messages.hotelAddedText : messages.hotelRemovedText }}
            </span>
        </div>
    </div>
    <a [href]="linkToWishlist" class="btn-to-wishlist">
        {{ messages.toCabinetText }}
    </a>
</div>
